import { UseQueryResult } from "@tanstack/react-query";
import { useEffect } from "react";
import { DefaultValues, FieldValues, UseFormReturn } from "react-hook-form";

export const useFormResetWithQueryData = <R, F extends FieldValues>(
  form: UseFormReturn<F>,
  query?: UseQueryResult<R, Error>,
) => {
  useEffect(() => {
    if (query?.data) {
      const formValues = Object.fromEntries(
        Object.entries(query.data).filter(([, value]) => value != null),
      ) as DefaultValues<F>;
      form.reset(formValues);
    }
  }, [form, query?.data]);
};
